import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=15f6b36b&"
import script from "./Update.vue?vue&type=script&lang=babel&"
export * from "./Update.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports